import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { LoginBoxDialogOptions, LoginBoxDialogResult } from "./loginbox-dialog";
import { LoginBoxDialogComponent } from "./loginbox-dialog.component";


@Injectable()
export class LoginBoxDialogService {

    constructor(private matDialog: MatDialog) {}

    // #region Close All Dialogs Service Call

    CloseAllDialogs(): void {
        this.matDialog.closeAll();
    }

    // #endregion

    // #region Open Login Box Dialog Service Call

    Open(options?: LoginBoxDialogOptions): Observable<LoginBoxDialogResult> {
        const openHandle = this.matDialog.open<LoginBoxDialogComponent>(LoginBoxDialogComponent, {
            disableClose: true,
            data: {
                TitleText: 'Credentials Required...',
                MessageText: '',
                InputHint: '',
                OKText: 'OK',
                CancelText: 'Cancel',
                ...options,
            },
            maxHeight: '85vh',
            // width: '500px',
            // height: (options && options.height) || '13rem'
        });

        return openHandle.afterClosed();
    }

    // #endregion
}